import { InjectionKey } from 'vue';
import { UserStore } from './providerTypes';

export const PROVIDED_USERSTORE: InjectionKey<UserStore> = Symbol('PROVIDED_USERSTORE');
